import { TGetLiferayQuickAccessContentResponse } from 'services/api/quick-access-content/types';

export const quickAccessContentMock: TGetLiferayQuickAccessContentResponse = {
  actions: {
    get: {
      method: 'GET',
      href: 'https://voebiz.dev2.smiles.com.br/o/headless-delivery/v1.0/sites/37966/structured-contents',
    },
  },
  facets: [],
  items: [
    {
      actions: {
        'get-rendered-content': {
          method: 'GET',
          href: 'https://voebiz.dev2.smiles.com.br/o/headless-delivery/v1.0/structured-contents/71691/rendered-content/{contentTemplateId}',
        },
        'get-rendered-content-by-display-page': {
          method: 'GET',
          href: 'https://voebiz.dev2.smiles.com.br/o/headless-delivery/v1.0/structured-contents/71691/rendered-content-by-display-page/{displayPageKey}',
        },
        get: {
          method: 'GET',
          href: 'https://voebiz.dev2.smiles.com.br/o/headless-delivery/v1.0/structured-contents/71691',
        },
      },
      availableLanguages: ['pt-BR'],
      contentFields: [
        {
          contentFieldValue: {
            data: 'Acessos rápidos',
          },
          dataType: 'string',
          inputControl: 'text',
          label: 'Title',
          name: 'title',
          nestedContentFields: [],
          repeatable: false,
        },
        {
          contentFieldValue: {},
          dataType: '',
          label: 'Cards',
          name: 'cards',
          nestedContentFields: [
            {
              contentFieldValue: {
                data: 'Minha categoria',
              },
              dataType: 'string',
              inputControl: 'text',
              label: 'Label',
              name: 'label',
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                data: '',
              },
              dataType: 'string',
              inputControl: 'text',
              label: 'Link',
              name: 'link',
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                image: {
                  contentType: 'Document',
                  contentUrl:
                    'https://voebiz.dev2.smiles.com.br/documents/37966/0/minha-categoria.svg/d5d89424-3bbe-114e-7dd0-51ab7c42bd52?t=1714764975552',
                  description: 'Minha categoria',
                  encodingFormat: 'image/svg+xml',
                  fileExtension: 'svg',
                  id: 71710,
                  sizeInBytes: 813,
                  title: 'minha-categoria.svg',
                },
              },
              dataType: 'image',
              label: 'Icon',
              name: 'icon',
              nestedContentFields: [],
              repeatable: false,
            },
          ],
          repeatable: true,
        },
        {
          contentFieldValue: {},
          dataType: '',
          label: 'Cards',
          name: 'cards',
          nestedContentFields: [
            {
              contentFieldValue: {
                data: 'Dados da conta',
              },
              dataType: 'string',
              inputControl: 'text',
              label: 'Label',
              name: 'label',
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                data: '',
              },
              dataType: 'string',
              inputControl: 'text',
              label: 'Link',
              name: 'link',
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                image: {
                  contentType: 'Document',
                  contentUrl:
                    'https://voebiz.dev2.smiles.com.br/documents/37966/0/dados-da-conta.svg/cca275b4-5570-6742-ad6b-86d177e1f1e0?t=1714765078515',
                  description: '',
                  encodingFormat: 'image/svg+xml',
                  fileExtension: 'svg',
                  id: 71719,
                  sizeInBytes: 412,
                  title: 'dados-da-conta.svg',
                },
              },
              dataType: 'image',
              label: 'Icon',
              name: 'icon',
              nestedContentFields: [],
              repeatable: false,
            },
          ],
          repeatable: true,
        },
        {
          contentFieldValue: {},
          dataType: '',
          label: 'Cards',
          name: 'cards',
          nestedContentFields: [
            {
              contentFieldValue: {
                data: 'Minha conta',
              },
              dataType: 'string',
              inputControl: 'text',
              label: 'Label',
              name: 'label',
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                data: '',
              },
              dataType: 'string',
              inputControl: 'text',
              label: 'Link',
              name: 'link',
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                image: {
                  contentType: 'Document',
                  contentUrl:
                    'https://voebiz.dev2.smiles.com.br/documents/37966/0/minha-conta.svg/64175718-af67-e328-7724-80f427c7f2fc?t=1714765126738',
                  description: 'Minha conta',
                  encodingFormat: 'image/svg+xml',
                  fileExtension: 'svg',
                  id: 71728,
                  sizeInBytes: 5439,
                  title: 'minha-conta.svg',
                },
              },
              dataType: 'image',
              label: 'Icon',
              name: 'icon',
              nestedContentFields: [],
              repeatable: false,
            },
          ],
          repeatable: true,
        },
        {
          contentFieldValue: {},
          dataType: '',
          label: 'Cards',
          name: 'cards',
          nestedContentFields: [
            {
              contentFieldValue: {
                data: 'Minha Equipe',
              },
              dataType: 'string',
              inputControl: 'text',
              label: 'Label',
              name: 'label',
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                data: '',
              },
              dataType: 'string',
              inputControl: 'text',
              label: 'Link',
              name: 'link',
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                image: {
                  contentType: 'Document',
                  contentUrl:
                    'https://voebiz.dev2.smiles.com.br/documents/37966/0/minha-equipe.svg/ad5a2e1a-4b41-0a73-dce8-a9fae354e146?t=1714765152179',
                  description: 'Minha Equipe',
                  encodingFormat: 'image/svg+xml',
                  fileExtension: 'svg',
                  id: 71737,
                  sizeInBytes: 957,
                  title: 'minha-equipe.svg',
                },
              },
              dataType: 'image',
              label: 'Icon',
              name: 'icon',
              nestedContentFields: [],
              repeatable: false,
            },
          ],
          repeatable: true,
        },
        {
          contentFieldValue: {},
          dataType: '',
          label: 'Cards',
          name: 'cards',
          nestedContentFields: [
            {
              contentFieldValue: {
                data: 'Meus voos',
              },
              dataType: 'string',
              inputControl: 'text',
              label: 'Label',
              name: 'label',
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                data: '',
              },
              dataType: 'string',
              inputControl: 'text',
              label: 'Link',
              name: 'link',
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                image: {
                  contentType: 'Document',
                  contentUrl:
                    'https://voebiz.dev2.smiles.com.br/documents/37966/0/meus-voos.svg/c508746c-2ce1-a817-bb07-3ca574d68076?t=1714765203647',
                  description: '',
                  encodingFormat: 'image/svg+xml',
                  fileExtension: 'svg',
                  id: 71746,
                  sizeInBytes: 469,
                  title: 'meus-voos.svg',
                },
              },
              dataType: 'image',
              label: 'Icon',
              name: 'icon',
              nestedContentFields: [],
              repeatable: false,
            },
          ],
          repeatable: true,
        },
        {
          contentFieldValue: {},
          dataType: '',
          label: 'Cards',
          name: 'cards',
          nestedContentFields: [
            {
              contentFieldValue: {
                data: 'Clube Smiles para Empresas',
              },
              dataType: 'string',
              inputControl: 'text',
              label: 'Label',
              name: 'label',
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                data: '',
              },
              dataType: 'string',
              inputControl: 'text',
              label: 'Link',
              name: 'link',
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                image: {
                  contentType: 'Document',
                  contentUrl:
                    'https://voebiz.dev2.smiles.com.br/documents/37966/0/clube-smiles.svg/71c2cfdd-e1d4-5ef7-d6ed-cc90bb6170a3?t=1714765229132',
                  description: 'Clube Smiles para Empresas',
                  encodingFormat: 'image/svg+xml',
                  fileExtension: 'svg',
                  id: 71755,
                  sizeInBytes: 432,
                  title: 'clube-smiles.svg',
                },
              },
              dataType: 'image',
              label: 'Icon',
              name: 'icon',
              nestedContentFields: [],
              repeatable: false,
            },
          ],
          repeatable: true,
        },
      ],
      contentStructureId: 44279,
      creator: {
        additionalName: '',
        contentType: 'UserAccount',
        familyName: 'Avarenga',
        givenName: 'Allan',
        id: 56536,
        image: '/image/user_portrait?img_id=69817&img_id_token=SODQyEVKFMRmQQlddBFYP%2BjFt%2Fc%3D&t=1715000793540',
        name: 'Allan Avarenga',
      },
      customFields: [],
      dateCreated: '2024-05-03T19:30:21Z',
      dateModified: '2024-05-03T19:40:39Z',
      datePublished: '2024-05-03T19:27:00Z',
      description: '',
      externalReferenceCode: '71689',
      friendlyUrlPath: 'my_account_quick_access',
      id: 71691,
      key: '71689',
      keywords: [],
      numberOfComments: 0,
      priority: 0.0,
      relatedContents: [],
      renderedContents: [
        {
          contentTemplateId: '44570',
          contentTemplateName: 'mam_my-access',
          markedAsDefault: true,
          renderedContentURL:
            'https://voebiz.dev2.smiles.com.br/o/headless-delivery/v1.0/structured-contents/71691/rendered-content/44570',
        },
      ],
      siteId: 37966,
      subscribed: false,
      taxonomyCategoryBriefs: [],
      title: 'my_account_quick_access',
      uuid: '97bddfb0-a2f6-dfcc-a2e2-ed63386763b9',
    },
  ],
  lastPage: 1,
  page: 1,
  pageSize: 20,
  totalCount: 1,
};
